import Component from 'inferno-component';
import { connect } from 'inferno-redux';
import { addDeck, addWordToDeck } from '../redux/decks';
import { cardsArrayContainsWord } from '../utils';
import LoadingSpinner from './LoadingSpinner';

function mapStateToProps(state) {
  return {
    deckItems: state.decks.items,
    user: state.auth.userInformation,
  };
}

class AddWordToDeckModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      addToDeckResponseMsg: null,
      deckItems: props.deckItems,
      isLoading: false,
      showAddDeckInput: false,
    };
  }

  toggleAddDeckInput = () => {
    this.setState({
      showAddDeckInput: !this.state.showAddDeckInput,
    });
  };

  addDeck = e => {
    e.preventDefault();
    const { sub } = this.props.user; // user's ID
    const { deckItems } = this.props;
    this.setState({ isLoading: true }, () => {
      this.props
        .addDeck(e.target.deckname.value, sub, deckItems)
        .then(deck => {
          this.setState({
            isLoading: false,
            showAddDeckInput: false,
          });
        })
        .catch(err => {
          console.error('err', err);
        });
    });
  };

  addSelectedWordToDeck = e => {
    e.preventDefault();
    const deckId = e.target.deckId.value;
    const wordId = e.target.wordId.value;
    const { deckItems } = this.props;

    this.setState({ addToDeckResponseMsg: null, isLoading: true }, () => {
      this.props
        .addWordToDeck(deckId, wordId, deckItems)
        .then(deck => {
          this.setState({
            addToDeckResponseMsg: `✓ Added to ${deck.deckName}`,
            isLoading: false,
          });
        })
        .catch(err => {
          this.setState({
            addToDeckResponseMsg: '✘ Error, please try again',
            isLoading: false,
          });
        });
    });
  };
  render() {
    const { toggleAddToDeckModal, wordId, modalWord, deckItems } = this.props;
    const { addToDeckResponseMsg, isLoading, showAddDeckInput } = this.state;
    return (
      <div className="add-to-deck--container">
        {isLoading && <LoadingSpinner />}
        <div className="add-to-deck--modal">
          <div className="header">
            <h2>{modalWord}</h2>
            <button className="close" onClick={toggleAddToDeckModal}>
              <span>&#215;</span>
            </button>
          </div>

          <p>Choose a flashcard deck to add this word to</p>
          <ul className="add-to-deck__body">
            {deckItems &&
              deckItems.map((deck, index) => {
                let addButtonIsDisabled = false;
                if (cardsArrayContainsWord(deck.cards, wordId)) {
                  addButtonIsDisabled = true;
                }
                const disabledButtonClass = addButtonIsDisabled
                  ? 'disabled-button'
                  : '';
                return (
                  <li
                    key={`deck-item-${deck.deckId}`}
                    className="add-to-deck__deck-listing"
                  >
                    <form method="post" onsubmit={this.addSelectedWordToDeck}>
                      <h2>
                        <span className="deck-name">{deck.deckName}</span>
                        <input
                          name="deckId"
                          type="hidden"
                          value={deck.deckId}
                        />
                        <input name="wordId" type="hidden" value={wordId} />
                        <button
                          className={disabledButtonClass}
                          type="submit"
                          disabled={addButtonIsDisabled}
                        >
                          <span className="card-count">
                            {deck.cards.length}
                          </span>{' '}
                          <span className="plus-button">+</span>
                        </button>
                      </h2>
                    </form>
                  </li>
                );
              })}
          </ul>

          <div className="add-to-deck__bottom-section">
            {!showAddDeckInput && (
              <div className="create-new">
                {addToDeckResponseMsg && (
                  <span className="success-message">
                    {addToDeckResponseMsg}
                  </span>
                )}
                <button className="button" onClick={this.toggleAddDeckInput}>
                  <span>+ Create new deck</span>
                </button>
              </div>
            )}
            <div className="add-to-deck__new-deck-input">
              {showAddDeckInput && (
                <form method="post" onsubmit={this.addDeck}>
                  <input
                    type="text"
                    placeholder="Name of new deck"
                    name="deckname"
                    required
                  />
                  <button className="button" type="submit">
                    Save deck
                  </button>
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, {
  addDeck,
  addWordToDeck,
})(AddWordToDeckModal);



// WEBPACK FOOTER //
// ./src/components/AddWordToDeckModal.js